import { PAGE_WRAPPER_STYLES } from 'src/styles/pageStyles';
import { cn } from 'src/lib/utils';
import { useAdminDashboardQuery } from 'src/generated/graphql';
import { RecentOrgsList } from '../RecentOrgsList';
import { WeeklyActivityChart } from '../WeeklyActivityChart';

export const AnalyticsPage = () => {
  const {
    data: dashboardData,
    loading: dashboardLoading,
    error: dashboardError,
  } = useAdminDashboardQuery();

  return (
    <div className={cn('flex flex-col py-8 gap-8', PAGE_WRAPPER_STYLES)}>
      {dashboardLoading ? (
        <div className="text-gray-500">Loading dashboard data...</div>
      ) : dashboardError ? (
        <div className="text-red-500">
          Error loading dashboard: {dashboardError.message}
        </div>
      ) : (
        <>
          <section>
            <h2 className="text-lg font-semibold mb-4 text-gray-900">
              Recent Organizations
            </h2>
            <RecentOrgsList
              organizations={
                dashboardData?.adminDashboard?.recentOrganizations ?? []
              }
            />
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-4 text-gray-900">
              Weekly Active Projects (Last 90 Days)
            </h2>
            <WeeklyActivityChart
              data={
                dashboardData?.adminDashboard?.weeklyActiveProjects ?? []
              }
              totals={
                dashboardData?.adminDashboard?.projectTotalsByOrg ?? []
              }
              valueLabel="Projects"
            />
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-4 text-gray-900">
              Weekly Active Users (Last 90 Days)
            </h2>
            <WeeklyActivityChart
              data={dashboardData?.adminDashboard?.weeklyActiveUsers ?? []}
              totals={dashboardData?.adminDashboard?.userTotalsByOrg ?? []}
              valueLabel="Users"
            />
          </section>
        </>
      )}
    </div>
  );
};
